export function htmlToDesc(html: string, max = 80): string {
  if (!html) return '';
  const text = new DOMParser()
    .parseFromString(html, 'text/html')
    .body.textContent
    ?.replace(/\s+/g, ' ')
    .trim() ?? '';
  return text.length > max ? text.slice(0, max).trimEnd() + '…' : text;
}
